export interface QuestionBaseDefinition {
	id: string
	slug?: string
	formFieldKey: string
	outputKey?: string
	labelTooltip?: string
	helpText?: string
	label: string
	questionType: QuestionType
	validations?: Validations
	sliderConfig?: {
		min?: number
		max?: number
		step?: number
		label?: string
		name?: string
		marks?: Array<{ value: number; label: string }>
	}
	step?: number
}

export function isQuestionRequired(question: QuestionBaseDefinition): boolean {
	return (
		question.validations?.required !== undefined &&
		getValidationConstraintValue(question.validations.required) === true
	)
}

export interface Validations {
	required?: ValidationConstraint<boolean>
	minLength?: ValidationConstraint<number>
	min?: ValidationConstraint<number>
	max?: ValidationConstraint<number>
}

export type ValidationConstraint<RequirementValue> =
	| StrongValidationConstraint<RequirementValue>
	| RequirementValue
export interface StrongValidationConstraint<RequirementValue> {
	value: RequirementValue
	message: string
}

export function isStrongValidationConstraint<RequirementValue>(
	constraint: ValidationConstraint<RequirementValue>,
): constraint is StrongValidationConstraint<RequirementValue> {
	return (
		typeof constraint === 'object' &&
		constraint !== null &&
		constraint !== undefined &&
		'value' in constraint &&
		'message' in constraint
	)
}

export function getValidationConstraintValue<RequirementValue>(
	validationConstraint: ValidationConstraint<RequirementValue>,
): RequirementValue {
	return isStrongValidationConstraint(validationConstraint)
		? validationConstraint.value
		: validationConstraint
}

export interface QuestionDefinition extends QuestionBaseDefinition {
	options?: QuestionOption[]
}

export const QuestionTypes = {
	SingleSelect: 'singleSelect',
	MultiSelect: 'multiSelect',
	TextInput: 'textInput',
	Slider: 'slider',
	NumberInput: 'numberInput',
	CurrencyInput: 'currencyInput',
	DocumentUpload: 'documentUpload',
} as const

export type QuestionType = (typeof QuestionTypes)[keyof typeof QuestionTypes]

export type QuestionOption = {
	label: string
	value: string | number
	subquestions?: QuestionDefinition[]
}

export type QuestionWithAnswer = {
	questionId: string
	questionType: string
	questionLabel: string
	options: string[] | null
	answer: string
	parentQuestionId?: string
}

export type UploadedFileMetadata = {
	fileId: string
	fileName: string
	url: string
}

export type FormikValues = Record<string, unknown>
